/**
 * Module-level stack of open dialog IDs. The {@link Dialog} component pushes
 * its `useId()` on mount and pops it on unmount; the Escape-key handler only
 * fires for the top-most entry. This prevents Escape in a stacked sub-dialog
 * from also closing its parent dialog (the prior implementation attached the
 * keydown listener to `window`, so every open dialog received the event).
 *
 * Kept module-level (not a React context) because (a) dialogs may live in
 * different React trees via portals later, and (b) the stack semantics are
 * inherently global — only one dialog can be "top" at any moment regardless of
 * component-tree structure.
 */

const stack: string[] = [];

export function pushDialog(id: string): void {
  stack.push(id);
}

export function popDialog(id: string): void {
  const i = stack.lastIndexOf(id);
  if (i >= 0) stack.splice(i, 1);
}

export function isTopDialog(id: string): boolean {
  return stack[stack.length - 1] === id;
}

/** Test-only helper: reset the stack between unrelated test cases. */
export function _resetDialogStack(): void {
  stack.length = 0;
}
